import {
    Button,
    MenuItem,
    Modal,
    TextField,
    FormControlLabel,
    Checkbox,
    FormGroup,
    Typography,
    InputAdornment,
    Autocomplete
} from "@mui/material";
import { React, useState, useContext, useEffect } from 'react'
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { Moneda } from "../../../Helpers/Moneda";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";

const ModalAgregarPowergard = ({ updatedata, idtasa, onClose, open, idpowergard, setIdPaquete }) => {

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [clienteslist, setClienteList] = useState([]);
    const [vendedores, setVendedores] = useState([]);

    const [powergard, setPowergard] = useState({
        sucursal: "",
        cliente: "",
        ot: "",
        serie: "",
        costo: 0,
        facturacion: 0,
        fechaFacturacion: "",
        cobertura: "",
        tipo: "",
        vendedor: 0,
        contrato: ""
    });

    const Editar = () => {

        if (idpowergard !== null || idpowergard !== "" || idpowergard !== -1 || idpowergard !== undefined) {
            request
                .get(`Powergard/ObtenerID?idpowergard=${idpowergard}`)
                .then((result) => {
                    const rawFecha = result.fecha_facturacion;
                    const fecha = new Date(rawFecha);

                    const fechaFormateada = fecha.toISOString().split('T')[0];
                    console.log(result)
                    setPowergard({
                        ...powergard,
                        sucursal: result.idsucursal,
                        cliente: result.idcliente,
                        ot: result.num_ot,
                        serie: result.serie,
                        costo: result.costo,
                        facturacion: result.facturacion,
                        fechaFacturacion: fechaFormateada,
                        cobertura: result.cobertura,
                        tipo: result.tipo,
                        vendedor: result.idvendedor,
                        contrato: result.contrato
                    })
                })
                .catch((error) => {
                    Swal.fire("INTERESES", JSON.stringify(error), "error");
                });

        } else {
            return;
        }
    }

    useEffect(() => {

        if (idpowergard !== undefined && idpowergard !== null && Number(idpowergard) > 0) {
            Editar();
        } else {

        }
    }, [updatedata]);


    const onGuardar = () => {

        const post = {
            idpowergard: idpowergard,
            idsucursal: powergard.sucursal,
            idcliente: powergard.cliente,
            serie: powergard.serie,
            facturacion: powergard.facturacion,
            costo: powergard.costo,
            tipo: powergard.tipo,
            fecha_facturacion: powergard.fechaFacturacion,
            num_ot: powergard.ot,
            idvendedor: powergard.vendedor,
            cobertura: powergard.cobertura,
            contrato: powergard.contrato
        }

        // Verificar campos vacíos o undefined
        const camposInvalidos = Object.entries(post)
            .filter(([key, value]) => value === "" || value === undefined)
            .map(([key]) => key);

        if (camposInvalidos.length > 0) {
            Swal.fire({
                icon: 'warning',
                title: 'POWERGARD',
                html: `Los siguientes campos están vacíos:<br><strong>${camposInvalidos.join('</strong>, <strong>')}</strong>`,
                confirmButtonText: 'Aceptar'
            });
            return false;
        }


        const soloNumerosRegex = /^\d+$/;

        if (!soloNumerosRegex.test(powergard.ot)) {
            Swal.fire({
                icon: 'error',
                title: 'POWERGARD',
                text: 'El campo "Orden de Trabajo" solo pueden contener números.',
                confirmButtonText: 'Aceptar'
            });
            return false;
        }

        request
            .post("Powergard", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                updatedata()
                await Swal.fire({
                    title: "POWERGARD",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setPowergard({
                    ...powergard,
                    sucursal: 0,
                    cliente: "",
                    ot: "",
                    serie: "",
                    costo: 0,
                    facturacion: 0,
                    fechaFacturacion: "",
                    cobertura: "",
                    tipo: "",
                    vendedor: 0
                })
                onClose();
                updatedata()
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("POWERGARD", JSON.stringify(error), "error");
            });
    }

    const onCerrar = () => {
        setPowergard({
            ...powergard,
            sucursal: 0,
            cliente: "",
            ot: "",
            serie: "",
            costo: 0,
            facturacion: 0,
            fechaFacturacion: "",
            cobertura: "",
            tipo: "",
            vendedor: 0
        })
        setIdPaquete(-1)
        onClose()
    }


    useEffect(() => {
        request
            .get("Clientes/DropDownList")
            .then((result) => {
                setClienteList(result);
            })
            .catch((error) => {
                Swal.fire("CLIENTES", JSON.stringify(error), "error");
            });

        request
            .get("DDLVendedor/ListadoALL")
            .then((result) => {
                // setLoading(false);
                setVendedores(result);
            })
            .catch((error) => {
                // setLoading(false);
                Swal.fire("VENDEDOR", JSON.stringify(error), "error");
            });
    }, []);

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setPowergard({
            ...powergard,
            [prop]: sinComas,
        });
    };

    const formatWithCommas = (value) => {
        if (!value) return '';
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    console.log(powergard)
    return (
        <Modal open={open}>
            <div className="modal-agregar-powergard-main-container">
                <div className="credito-agregar-modal-title">

                    <div className="modal-agregar-powergard-main-titulo">
                        <h3>AGREGAR POWERGARD </h3>
                    </div>
                </div>
                <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
                </div>

                <div>
                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            // fullWidth
                            size="small"
                            label="Sucursal"
                            variant="outlined"
                            className="cell-corta"
                            select
                            type="text"
                            onChange={({ target }) => {
                                setPowergard({
                                    ...powergard,
                                    sucursal: target.value
                                });
                            }}
                            value={powergard.sucursal}
                        >
                            <MenuItem value={"1"}>NAVOLATO</MenuItem>
                            <MenuItem value={"2"}>TEPIC</MenuItem>
                            <MenuItem value={"11"}>CAIMANERO</MenuItem>
                            <MenuItem value={"12"}>SAN JOSE</MenuItem>
                            <MenuItem value={"21"}>ELDORADO</MenuItem>
                            <MenuItem value={"22"}>SANTIAGO I.</MenuItem>
                            <MenuItem value={"31"}>COSTA RICA</MenuItem>
                            <MenuItem value={"32"}>TECUALA</MenuItem>
                            <MenuItem value={"41"}>LA CRUZ</MenuItem>
                            <MenuItem value={"51"}>EL ROSARIO</MenuItem>
                            <MenuItem value={"52"}>SAN VICENTE</MenuItem>
                            <MenuItem value={"61"}>VILLA UNION</MenuItem>
                        </TextField>

                        <Autocomplete
                            id="dash-razonsocial"
                            freeSolo
                            className="celda-clientes"
                            fullWidth
                            value={
                                powergard.cliente != null
                                    ? clienteslist.find(c => c.id.toString() === powergard.cliente.toString()) || null
                                    : null
                            }

                            onChange={(event, newValue) => {
                                if (typeof newValue === 'object' && newValue !== null) {
                                    setPowergard({
                                        ...powergard,
                                        cliente: newValue.id // <-- Aquí guardas el id
                                    });
                                } else {
                                    // Si es un string (por ejemplo, en modo freeSolo)
                                    setPowergard({
                                        ...powergard,
                                        cliente: newValue
                                    });
                                }
                            }}
                            options={clienteslist}
                            getOptionLabel={(option) =>
                                typeof option === 'string' ? option : option.display
                            }
                            renderInput={(params) => (
                                <TextField
                                    sx={{
                                        height: '40px',
                                        '& .MuiInputBase-root': {
                                            height: '40px',
                                            minHeight: '40px',
                                            fontSize: '0.875rem',
                                            padding: '0 8px',
                                        },
                                        '& input': {
                                            height: '40px',
                                            padding: '0 8px',
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            alignItems: 'center',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '0.85rem',
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: '0',
                                        },
                                    }}
                                    {...params}
                                    label="SELECCIONAR CLIENTE"
                                    InputLabelProps={{ shrink: true }} // Hace que el label no se solape
                                />
                            )}
                        />

                    </div>
                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            id="clientes-documento"
                            label="OT"
                            type="text"
                            value={powergard.ot}
                            onChange={({ target }) => {
                                ValOnlyNumber("ot", target.value, onChange, true, 15);
                            }}
                            // onChange={({ target }) => {
                            //     setPowergard({
                            //         ...powergard,

                            //         ot: target.value,
                            //     });
                            // }}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            id="clientes-documento"
                            label="Serie"
                            type="text"
                            value={powergard.serie}
                            onChange={({ target }) => {
                                setPowergard({
                                    ...powergard,

                                    serie: target.value,
                                });
                            }}
                            sx={{
                                width: 540,
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            id="costo"
                            label="Costo"
                            type="text"
                            value={powergard.costo === 0 ? 0 : formatWithCommas(powergard.costo)}
                            onKeyUp={(input) => Moneda(input.target)}

                            onChange={({ target }) => {
                                ValOnlyNumber("costo", target.value, onChange, true, 10);
                            }}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            id="facturacion"
                            label="Facturacion"
                            type="text"
                            value={powergard.facturacion === 0 ? 0 : formatWithCommas(powergard.facturacion)}
                            onChange={({ target }) => {
                                ValOnlyNumber("facturacion", target.value, onChange, true, 10);
                            }}
                            onKeyUp={(input) => Moneda(input.target)}
                            sx={{
                                width: 540,
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>

                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            fullWidth
                            label="Fecha Facturación"
                            color="success"
                            type="date"
                            className="modal-agregar-powergard-fecha-facturacion"
                            value={powergard.fechaFacturacion}
                            onChange={({ target }) =>
                                setPowergard({ ...powergard, fechaFacturacion: target.value })
                            }
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {/* <BusinessIcon /> */}
                                    </InputAdornment>
                                ),
                            }}
                            inputProps={{
                                maxLength: 100,
                            }}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />

                        <TextField
                            id="clientes-documento"
                            label="Cobertura"
                            type="text"
                            value={powergard.cobertura}
                            onChange={({ target }) => {
                                setPowergard({
                                    ...powergard,

                                    cobertura: target.value,
                                });
                            }}
                            sx={{
                                width: 540,
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            fullWidth
                            size="small"
                            label="Interna/Externa"
                            variant="outlined"
                            className="cell-corta"
                            select
                            type="text"
                            onChange={({ target }) => {
                                setPowergard({
                                    ...powergard,
                                    tipo: target.value
                                });
                            }}
                            value={powergard.tipo}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        >
                            <MenuItem value={"I"}>Interna</MenuItem>
                            <MenuItem value={"E"}>Externa</MenuItem>
                        </TextField>

                        <Autocomplete
                            fullWidth
                            size="small"
                            disablePortal
                            options={vendedores}
                            value={vendedores.find(v => v.idvendedor === powergard.vendedor) || null}
                            getOptionLabel={(option) => option.vendedor ?? ""}
                            onChange={(e, newValue) => {
                                setPowergard({
                                    ...powergard,
                                    vendedor: newValue ? newValue.idvendedor : 0,
                                });
                            }}
                            sx={{
                                width: 540,
                                '& .MuiInputBase-root': {
                                    height: '40px !important',
                                    minHeight: '40px',
                                    fontSize: '0.875rem',
                                    paddingRight: '8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: 0,
                                }
                            }}
                            renderInput={(params) =>
                                <TextField {...params} label="Vendedor" InputLabelProps={{ shrink: true }} />
                            }
                        />

                    </div>

                    <div className="modal-agregar-powergard-solo-input">
                        <TextField
                            fullWidth
                            size="small"
                            label="Contrato"
                            variant="outlined"
                            className="cell-corta"
                            select
                            type="text"
                            onChange={({ target }) => {
                                setPowergard({
                                    ...powergard,
                                    contrato: target.value
                                });
                            }}
                            value={powergard.contrato}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        >
                            <MenuItem value={"C"}>Comprado</MenuItem>
                            <MenuItem value={"P"}>Pendiente</MenuItem>
                        </TextField>

                    </div>
                </div>

                <div className="credito-crear-tasa-interes-modal-button-container ">
                    <Button onClick={onCerrar} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button variant="contained"
                        onClick={() => onGuardar()}
                    >
                        Agregar
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default ModalAgregarPowergard
